export default "__VITE_ASSET__C7o6f2ul__"